import $ from "jquery";
import { Fragment, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";
import { WishlistItem } from "./addWhistList";
import { useAuth } from "../../Context/AuthContext";
import { QuantityStripper } from "./quantityStripper";
import { ConvertToFloat } from "./common";
import { ImageWithDefault } from "./imageWithDefault";
import { contructProductData } from "./algoliaInstantLib";
import useAddToCart from "../../Context/hook/useAddtoCart";
import { PriceStockPopup } from "./priceStockPopup";
import { useDevice } from "../../Context/hook/useDeviceType";
import { useOpenProduct } from "../../View/ProductHybrid/productPageOverlay/overlayNavigation";
import { ProductLink } from "./productLink";

export const ProductCardAlgolia = ({ data, catFilter }) => {
  const { CartItem } = useContext(GlobalContext);
  const [ProductData, setProductData] = useState();
  const [cartParams, setCartParams] = useState(null);
  const [isAdded, setIsadded] = useState(false);
  const [qty, setQty] = useState({});
  const { userId, eBayBlock, isBrowseOnly, isAuthenticated } = useAuth();
  const isGuest = isAuthenticated === false;
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (data && data.productId) {
      const productData = contructProductData(data, catFilter);
      if (productData) {
        setProductData(productData);
        setQty({ prod_id: data.productId, qty: 1 });
        setCartParams({
          code: productData.sku,
          desc: productData.description,
          img: productData.prodImage,
        });
      }
    }
  }, [data, catFilter]);

  useEffect(() => {
    if (data && CartItem && CartItem.cartItem && CartItem.cartItem.length > 0) {
      var products = CartItem.cartItem;
      var filterProductId = products.find((item) => String(item.prod_id) == String(data.productId));
      setIsadded(filterProductId ? true : false);
      setQty({
        prod_id: data.productId,
        qty: filterProductId?.qty ?? 0,
      });
    } else {
      setIsadded(false);
      setQty({ prod_id: data.productId, qty: 0 });
    }
  }, [CartItem, data]);

  return (
    <Fragment>
      {ProductData && (
        <div className="product-list" data-id={ProductData.productId}>
          <div className="product-items">
            <ProductLink to={ProductData.link}>
              <ImageWithDefault src={ProductData.prodImage} alt={ProductData.productId} />
            </ProductLink>
            <div className="wishlist-products">
              {!isGuest && <WishlistItem productId={ProductData.productId} />}
              {ProductData.isClearance ? (
                <small className="product-stage new-clearance">CLEARANCE</small>
              ) : (
                ProductData.isNew && <small className="product-stage new-product">New</small>
              )}
            </div>
          </div>
          <div className="product-details">
            <h6 className="product-title" style={{ height: "44px", overflow: "hidden" }}>
              <ProductLink to={ProductData.link}>
                {ProductData.description}
              </ProductLink>
            </h6>
            {!isBrowseOnly ? (
              <Fragment>
                {ProductData.isfamily ? (
                  <ProductFamily item={ProductData} />
                ) : ProductData.isSubstitute ? (
                  <ProductReplacement item={ProductData} />
                ) : ProductData.isDiscontinued || ProductData.isUnavailable ? (
                  <ProductUnavailable item={ProductData} />
                ) : (
                  <Fragment>
                    {!isGuest &&
                      (isAdded && (!eBayBlock || !ProductData.eBayBlock) ? (
                        <div className="product-price">
                          <p>$ {ConvertToFloat(ProductData.price)}</p>
                          <span className="pro-added">
                            <i className="fa-solid fa-check" /> Added
                          </span>
                        </div>
                      ) : (
                        <div className="product-price">
                          <p>$ {ConvertToFloat(ProductData.price)}</p>
                          {isAdded ? (
                            <span className="pro-added">
                              <i className="fa-solid fa-check" /> Added
                            </span>
                          ) : (
                            <PriceStockPopup product={ProductData} />
                          )}
                        </div>
                      ))}
                    <div className="product-code">Code: {ProductData.sku}</div>
                    {!isGuest &&
                      (eBayBlock && ProductData.eBayBlock ? (
                        <div className="product-button">
                          <button type="button" className="btn btn-products btn-unavailable">
                            Unavailable
                          </button>
                        </div>
                      ) : (
                        <QuantityStripper prd={qty} params={cartParams} wrapperClass="flex-nowrap" />
                      ))}
                  </Fragment>
                )}
              </Fragment>
            ) : (
              <BrowseOnlyContainer item={ProductData} />
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

const ProductReplacement = ({ item }) => {
  const { isAuthenticated } = useAuth();
  const openProduct = useOpenProduct(isAuthenticated === true);
  return (
    <Fragment>
      <div className="product-unavailable">
        <p>Substituted</p>
      </div>
      <div className="product-code product-substituted">
        <p>
          Replacement:
          <ProductLink to={item.wesSubstituteUrl}>
            {item.productSubstitute}
          </ProductLink>
        </p>
      </div>
      <div className="product-button">
        <button
          type="button"
          className="btn btn-products btn-unavailable"
          onClick={() => openProduct(item.wesSubstituteUrl)}
        >
          View Substituted Product
        </button>
      </div>
    </Fragment>
  );
};

const ProductUnavailable = ({ item }) => {
  return (
    <Fragment>
      <div className="product-unavailable">
        <p>Temporarily Unavailable</p>
      </div>
      <div className="product-code">Code: {item.sku}</div>
      <div className="product-button">
        <button type="button" className="btn btn-products btn-unavailable">
          Unavailable
        </button>
      </div>
    </Fragment>
  );
};

const ProductFamily = ({ item }) => {
  const { isAuthenticated } = useAuth();
  const openProduct = useOpenProduct(isAuthenticated === true);
  return (
    <Fragment>
      {isAuthenticated !== false && (
        <div className="product-price">
          <p style={{ visibility: item.hidePrice ? "hidden" : "visible" }}> $ {ConvertToFloat(item.price)}</p>
        </div>
      )}
      <div className="product-code buying-options">Code: {item.sku}</div>

      {isAuthenticated !== false && (
        <div className="product-button button-effect">
          <button
            type="button"
            onClick={() => openProduct(item.link)}
            className="btn btn-products btn-buying"
          >
            <span className="wes-buying-option" />
            <span className="btn-options">Buying Options</span>
          </button>
        </div>
      )}
    </Fragment>
  );
};

const BrowseOnlyContainer = ({ item }) => {
  return (
    <Fragment>
      <div className="product-price">
        <p>$ {ConvertToFloat(item.price)}</p>
        <PriceStockPopup product={item} />
      </div>
      {item.isfamily ? (
        <ProductLink to={item.link}>
          <div className="product-code  text-uppercase">View Options</div>
        </ProductLink>
      ) : (
        <div className="product-code">Code: {item.sku}</div>
      )}
    </Fragment>
  );
};
